<template>
  <div
    class="c-rect-item__header" 
    @mousedown.prevent="handleMousedownOnHeader($event)"
  >
    <div class="cols-row">
      <div class="col-left">
        <slot name="col-left">
          <v-btn
            @mousedown.prevent.stop
            @click.stop="routeAdd()"
            x-small
            fab 
            outlined
            color="#09C006"
            :disabled="disabled_add_route"
            title="Додати маршрут на карту"
          ><v-icon>mdi-plus</v-icon></v-btn>
        </slot>
      </div>
      <div class="col-center">
        <slot name="col-center" />
      </div>
      <div class="col-right">
        <slot name="col-right">
          <v-btn
            @mousedown.prevent.stop
            @click.stop="rectRemove()"
            x-small
            fab 
            outlined
            color="#9B1C1C"
            :disabled="disabled_rect_remove"
            title="Видалити карту"
          ><v-icon>mdi-close</v-icon></v-btn>
        </slot>
      </div>
    </div>

    <v-progress-linear
      v-if="is_loading"
      height="2"
      indeterminate
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: 'c-rect-item-header',
  props: {
    rect: {
      type: Object,
      default() {
        return {}
      }
    },
    is_loading: {
      type: Boolean,
      default: false
    },
    disabled_add_route: {
      type: Boolean,
      default: false
    },
    disabled_rect_remove: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    rectActivate(rect = this.rect) {
      this.$emit('rectActivate', rect)
    },
    rectRemove(rect_id = this.rect.rect_id) {
      this.$emit('rectRemove', rect_id)
      this.rectActivate()
    },
    routeAdd(rect_id = this.rect.rect_id) {
      this.$emit('routeAdd', rect_id)
      this.rectActivate()
    },
    handleMousedownOnHeader({ clientX, clientY }) {
      const customEvent = new CustomEvent('custom_mousedown', { detail: { clientX, clientY } })
      window.dispatchEvent(customEvent)
      // old code backward
      this.rectActivate()
    }
  }
}
</script>

<style lang="scss">
  .c-rect-item {
    &__header {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      background: #fff;
      z-index: 2;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      .v-btn--fab.v-size--x-small {
        height: 24px;
        width: 24px;
      }
      .cols-row {
        position: relative;
        min-height: 36px;
        .col-left,
        .col-right {
          position: absolute;
          top: 5px;
          padding: 0 5px;
          max-width: 34px;
        }
        .col-left {
          left: 0;
        }
        .col-right {
          right: 0;
        }
        .col-center {
          padding: 0 34px;
        }
      }
    }
  }
</style>